export default () => ({
  noCleanIcon: {
    '&.MuiAutocomplete-hasClearIcon': {
      '& .MuiOutlinedInput-root': {
        pr: '24px !important'
      }
    }
  }
});
